export const capAmountWarning = (translate) => (value) => {
  if (value === 0) {
    return translate(
      'You have set a cap limit at $0. This incentive will not provide any financial benefits, even when applied.'
    )
  }
  return ''
}
export const maxSystemSizeWarning = (translate) => (value) => {
  if (value === 0) {
    return translate('You have set a max system size as 0kW. This incentive will not be applied to any project.')
  }
  return ''
}

export const maxBatterySizeWarning = (translate) => (value) => {
  if (value === 0) {
    return translate('You have set a max battery size as 0kWh. This incentive will not be applied to any project.')
  }
  return ''
}
